import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UnderConstruction from "../components/UnderConstruction";

const HumanHealthPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        <UnderConstruction />

      {/* </MasterLayout> */}

    </>
  );
};

export default HumanHealthPage; 
